// product page js

// for short product description js //
const topProductParagraphs = document.querySelectorAll(".TopProductParagraph");
const movingParagraph = document.getElementById("MovingParagraph");

if (topProductParagraphs.length > 0 && movingParagraph) {
  topProductParagraphs.forEach((paragraph) => {
    paragraph.innerHTML = movingParagraph.innerHTML;
  });
}

// for product bottom desciption //

const prodlowsubhdrmain = document.querySelector(".prod-low-sub-hdr-main");
const underheadersection = document.querySelector(".under-header-section");

if (prodlowsubhdrmain && underheadersection) {
  prodlowsubhdrmain.innerHTML = underheadersection.innerHTML;
}

// for advantages image
// Get the elements with class "prod-advantages" and "advantages"
var prodAdvantages = document.querySelector(".prod-advantages");
var advantages = document.querySelector(".advantages");

// Check if both elements exist
if (prodAdvantages && advantages) {
  // Detach the "advantages" element
  var detachedAdvantages = advantages.cloneNode(true);
  advantages.parentNode.removeChild(advantages);

  // Append the contents of the detached "advantages" element to the "prod-advantages" element
  prodAdvantages.innerHTML = detachedAdvantages.innerHTML;
}

// advantages block js //
// Select the elements with class 'prod-advantages' and 'advantages'
var prodAdvantages = document.querySelector(".prod-advantages");
var advantages = document.querySelector(".advantages");

if (prodAdvantages && advantages) {
  // Clone the contents of the 'advantages' element
  var advantagesContent = advantages.innerHTML;

  // Set the HTML of 'prod-advantages' to the cloned content
  prodAdvantages.innerHTML = advantagesContent;
}

// review widget js
